import { Translate } from '@dreryk/react-common';
import { appendTestableElementAttributes } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../../translations';
import { StyledCard } from '../shared/Card.styled';

import { ConfirmedAppointmentsLoader } from './ConfirmedAppointments.loader';
import { StyledConfirmedAppointments } from './ConfirmedAppointments.styled';
import { ConfirmedAppointmentsCardCount } from './ConfirmedAppointmentsCardCount';
import { ConfirmedAppointmentsChart } from './ConfirmedAppointmentsChart';

export const ConfirmedAppointmentsCard = (): JSX.Element => {
   return (
      <StyledCard {...appendTestableElementAttributes('confirmed')}>
         <ConfirmedAppointmentsLoader>
            {({ visitsView }) => (
               <StyledConfirmedAppointments direction='column' gap={12} flex='1'>
                  <ConfirmedAppointmentsCardCount visitsView={visitsView} />
                  <Translate>{dashboardTranslationKeys.cards.confirmed}</Translate>
                  <ConfirmedAppointmentsChart visitsView={visitsView} />
               </StyledConfirmedAppointments>
            )}
         </ConfirmedAppointmentsLoader>
      </StyledCard>
   );
};
